/**
 * Bhutanese ngultrum.
 */
export var BTN = {
  code: 'BTN',
  base: 10,
  exponent: 2
};